import React from "react"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const ProductionLineSkeleton = () => {
   return (
      <div className="production-line-skeleton">
         <div className="production-line-skeleton-row ">
            <UnitSkeleton shape="rounded" size="xsmall" />
            <UnitSkeleton shape="rounded" size="medium" />
            <UnitSkeleton shape="rounded" size="xsmall" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="xsmall" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="large" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="large" />
         </div>
         <div className=" production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="large" />
         </div>
      </div>
   )
}

export default ProductionLineSkeleton
